(function () {
  'use strict';

  if (window.MrMapleProductCompare) return;

  var MODAL_ID = 'mm-product-compare-modal';
  var USDA_ZONE_MAP_URL = 'https://planthardiness.ars.usda.gov/';
  var SIDES = ['left', 'right'];
  var SIDE_LABELS = {
    left: 'Product 1',
    right: 'Product 2',
  };
  var TRAIT_ORDER = [
    { key: 'zone', label: 'Zone' },
    { key: 'height', label: 'Height' },
    { key: 'habit', label: 'Growth habit' },
    { key: 'colors', label: 'Colors' },
    { key: 'growth', label: 'Rate of growth' },
  ];
  var COLOR_WORDS = [
    'variegated',
    'chartreuse',
    'burgundy',
    'crimson',
    'scarlet',
    'maroon',
    'purple',
    'bronze',
    'orange',
    'yellow',
    'golden',
    'gold',
    'pink',
    'white',
    'cream',
    'green',
    'blue',
    'red',
    'lavender',
    'coral',
    'black',
    'silver',
    'gray',
    'grey',
    'creamy',
    'bluish',
    'reddish',
    'purplish',
    'silvery',
    'lime',
  ];
  var COLOR_LABELS = {
    grey: 'Gray',
    gold: 'Gold',
    golden: 'Golden',
    creamy: 'Cream',
    bluish: 'Blue',
    reddish: 'Red',
    purplish: 'Purple',
    silvery: 'Silver',
  };
  var COLOR_SWATCHES = {
    variegated: { background: 'linear-gradient(135deg, #f7efd4 0 42%, #2f7d32 42% 58%, #ffffff 58% 100%)', text: '#18212f' },
    chartreuse: { background: '#d5ef4f', text: '#18212f' },
    burgundy: { background: '#7b1e3a', text: '#ffffff' },
    crimson: { background: '#b91c1c', text: '#ffffff' },
    scarlet: { background: '#d7261e', text: '#ffffff' },
    maroon: { background: '#6f1d1b', text: '#ffffff' },
    purple: { background: '#6b3fa0', text: '#ffffff' },
    bronze: { background: '#b77932', text: '#18212f' },
    orange: { background: '#f58220', text: '#18212f' },
    yellow: { background: '#ffd84d', text: '#18212f' },
    golden: { background: '#d6a51d', text: '#18212f' },
    gold: { background: '#d6a51d', text: '#18212f' },
    pink: { background: '#f3a6c8', text: '#18212f' },
    white: { background: '#ffffff', text: '#18212f', border: 'rgba(24, 33, 47, 0.18)' },
    cream: { background: '#f4e8c1', text: '#18212f' },
    green: { background: '#2f7d32', text: '#ffffff' },
    blue: { background: '#2f6fbd', text: '#ffffff' },
    red: { background: '#c62828', text: '#ffffff' },
    lavender: { background: '#b99adf', text: '#18212f' },
    coral: { background: '#ff7f50', text: '#18212f' },
    black: { background: '#111111', text: '#ffffff' },
    silver: { background: '#c0c0c0', text: '#18212f' },
    gray: { background: '#808080', text: '#ffffff' },
    grey: { background: '#808080', text: '#ffffff' },
    lime: { background: '#a4d65e', text: '#18212f' },
  };
  var HABIT_TERMS = [
    { label: 'Vase-Shaped', aliases: ['vase-shaped', 'vase shaped', 'vase-like', 'vase like', 'vase shape'] },
    { label: 'Columnar', aliases: ['columnar'] },
    { label: 'Conical', aliases: ['conical', 'cone-shaped', 'cone shaped'] },
    { label: 'Pyramidal', aliases: ['pyramidal', 'pyramid-shaped', 'pyramid shaped', 'central leader'] },
    { label: 'Narrow', aliases: ['narrow', 'slender', 'thin', 'fastigiate'] },
    { label: 'Low-Growing', aliases: ['low-growing', 'low growing', 'low compact'] },
    { label: 'Prostrate', aliases: ['prostrate', 'ground-hugging', 'ground hugging'] },
    { label: 'Weeping', aliases: ['weeping', 'pendulous', 'cascading'] },
    { label: 'Mounding', aliases: ['mounding', 'mounded', 'mound-shaped', 'mound shaped'] },
    { label: 'Spreading', aliases: ['spreading', 'broad-spreading', 'broad spreading', 'wide-spreading', 'wide spreading', 'low-spreading', 'low spreading'] },
    { label: 'Oval', aliases: ['upright-oval', 'upright oval', 'oval', 'oval-shaped', 'oval shaped'] },
    { label: 'Rounded', aliases: ['rounded', 'round', 'globe-like', 'globe like', 'globe-shaped', 'globe shaped', 'globose'] },
    { label: 'Upright', aliases: ['upright', 'upright-growing', 'upright growing'] },
    { label: 'Arching', aliases: ['arching', 'arched'] },
    { label: 'Contorted', aliases: ['contorted', 'contorted-like', 'contorted like', 'twisting', 'twisted', 'curled', 'curly'] },
    { label: 'Dwarf', aliases: ['dwarf', 'miniature', 'miniature-sized', 'miniature sized'] },
    { label: 'Compact', aliases: ['tight dense', 'tight-dense', 'densely branched', 'densely-branched', 'dense branching', 'dense-branching', 'tight branching', 'tight growth', 'short internodes', 'short-internoded', 'compact', 'dense', 'tight'] },
    { label: 'Shrub', aliases: ['shrub', 'shrubby', 'shrub-like', 'shrub like'] },
  ];
  var HABIT_CONTEXT_PATTERN = /\b(habit|form|shape|canopy|branching|branches|silhouette|structure|stature|architecture|overall)\b/i;
  var HABIT_PLANT_CONTEXT_PATTERN = /\b(?:cultivar|selection|tree|shrub|conifer|maple|plant|seedlings?|forms?|develops?|grows?|has|with|overall|branching)\b/i;
  var GROWTH_RATE_THRESHOLDS = {
    slowFeetPerYear: 1,
    fastFeetPerYear: 2,
  };
  var CATALOG_DETAIL_KEYS = {
    zones: ['zones', 'zone', 'usdaZones', 'usda_zones', 'hardinessZones', 'hardiness_zones', 'min_max', 'Min/Max Zone'],
    minZone: ['minZone', 'min_zone', 'minimumZone', 'minimum_zone', 'Min Zone'],
    maxZone: ['maxZone', 'max_zone', 'maximumZone', 'maximum_zone', 'Max Zone'],
    averageHeight10yr: ['averageHeight10yr', 'average_height_10yr', 'Average Height (10YR)'],
    habit: ['habit', 'growthHabit', 'growth_habit', 'Growth Habit'],
    growthRate: ['growthRate', 'growth_rate', 'Growth Rate'],
    springColor: ['springColor', 'spring_color', 'Spring Color'],
    fallColor: ['fallColor', 'fall_color', 'Fall Color'],
    bloomColor: ['bloomColor', 'bloom_color', 'Bloom Color'],
    foliageColor: ['foliageColor', 'foliage_color', 'Foliage Color'],
  };
  var METAFIELD_KEYS = [
    { field: 'zones', namespace: 'custom', key: 'zones' },
    { field: 'minZone', namespace: 'custom', key: 'min_zone' },
    { field: 'maxZone', namespace: 'custom', key: 'max_zone' },
    { field: 'averageHeight10yr', namespace: 'custom', key: 'average_height_10yr' },
    { field: 'habit', namespace: 'custom', key: 'habit' },
    { field: 'growthRate', namespace: 'custom', key: 'growth_rate' },
    { field: 'springColor', namespace: 'custom', key: 'spring_color' },
    { field: 'fallColor', namespace: 'custom', key: 'fall_color' },
    { field: 'bloomColor', namespace: 'custom', key: 'bloom_color' },
    { field: 'foliageColor', namespace: 'custom', key: 'foliage_color' },
  ];
  var DESCRIPTION_CLEANUP_PATTERNS = [
    /(?:\*+\s*)?10\s+GALLON\s+TREE\s+SHIPS\s+WITHOUT\s+POT\s+DUE\s+TO\s+BOX\s+SIZE\s+CONSTRAINTS(?:\s*\*+)?[\s\S]*?10\s+gallon\s+tree\s+without\s+a\s+container\.?/gi,
    /The photo\(s\)\s+with\s+a\s+MrMaple\s+logo[\s\S]*?expressed\s+written\s+consent\s+from\s+the\s+owner\.?/gi,
    /Limited\s+Quantities\s+Available\s*!![\s\S]*?sell\s+out\s+of\s+certain\s+selections\.?/gi,
  ];

  var state = {
    modal: null,
    tooltip: null,
    tooltipTarget: null,
    lastFocus: null,
    left: null,
    right: null,
    searchTimers: {},
    searchControllers: {},
    galleryViewer: null,
    galleryViewerLastFocus: null,
  };

  function init() {
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('input', handleDocumentInput);
    document.addEventListener('change', handleDocumentChange);
    document.addEventListener('keydown', handleDocumentKeydown);
    document.addEventListener('pointerover', handleTooltipEnter);
    document.addEventListener('pointerout', handleTooltipLeave);
    document.addEventListener('pointerdown', hideCompareTooltip, true);
    window.addEventListener('scroll', positionCompareTooltip, true);
    window.addEventListener('resize', positionCompareTooltip);
    window.MrMapleProductCompare = {
      open: openCompare,
      close: closeCompare,
      extractTraits: extractTraits,
      normalizeProduct: normalizeProduct,
    };
  }

  function handleDocumentClick(event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    var compareButton = target.closest('[data-product-compare-button]');
    if (compareButton) {
      event.preventDefault();
      event.stopPropagation();
      var seed = getProductSeed(compareButton);
      if (seed && seed.handle) {
        openCompare(seed, { focusSide: 'right' });
      }
      return;
    }

    var actionButton = target.closest('[data-product-compare-action]');
    if (actionButton) {
      event.preventDefault();
      event.stopPropagation();
      handleProductAction(actionButton);
      return;
    }

    var galleryButton = target.closest('[data-product-compare-gallery-open]');
    if (galleryButton) {
      event.preventDefault();
      event.stopPropagation();
      openGalleryViewer(galleryButton);
      return;
    }

    if (target.closest('[data-product-compare-gallery-close]')) {
      event.preventDefault();
      event.stopPropagation();
      closeGalleryViewer();
      return;
    }

    if (target.closest('[data-product-compare-close]')) {
      event.preventDefault();
      closeCompare();
      return;
    }

    var result = target.closest('[data-product-compare-search-result]');
    if (result) {
      event.preventDefault();
      var side = result.getAttribute('data-side') || 'right';
      var product = getProductSeed(result);
      if (product && product.handle) {
        hideSearchResults(side);
        setSearchValue(side, '');
        setSideProduct(side, product);
      }
    }
  }

  function handleDocumentInput(event) {
    var input = event.target instanceof Element ? event.target.closest('[data-product-compare-search-input]') : null;
    if (!input) return;
    var side = input.getAttribute('data-side') || 'right';
    scheduleProductSearch(side, input.value || '');
  }

  function handleDocumentChange(event) {
    var select = event.target instanceof Element ? event.target.closest('[data-product-compare-size-select]') : null;
    if (!select) return;
    var side = select.getAttribute('data-side') || '';
    if (!side || SIDES.indexOf(side) === -1 || !state[side]) return;
    var variantId = normalizeVariantId(select.value);
    if (!variantId) return;
    state[side] = Object.assign({}, state[side], { variantId: variantId });
    renderSide(side);
  }

  function handleDocumentKeydown(event) {
    if (event.key === 'Escape' && state.galleryViewer && !state.galleryViewer.hidden) {
      event.preventDefault();
      closeGalleryViewer();
      return;
    }

    if (event.key === 'Escape' && state.modal && !state.modal.hidden) {
      var target = event.target instanceof Element ? event.target : null;
      if (target && target.closest('[data-product-compare-search-results]:not([hidden])')) {
        hideSearchResults(target.getAttribute('data-side') || 'right');
        return;
      }
      event.preventDefault();
      closeCompare();
    }
  }

  function handleTooltipEnter(event) {
    var target = event.target instanceof Element ? event.target.closest('[data-product-compare-tooltip]') : null;
    if (!target) return;
    if (!isHoverTooltipEvent(event)) return;
    showCompareTooltip(target);
  }

  function handleTooltipLeave(event) {
    var target = event.target instanceof Element ? event.target.closest('[data-product-compare-tooltip]') : null;
    if (!target || target !== state.tooltipTarget) return;
    if (event.relatedTarget instanceof Node && target.contains(event.relatedTarget)) return;
    hideCompareTooltip();
  }

  function isHoverTooltipEvent(event) {
    if (event && event.pointerType === 'touch') return false;
    if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return false;
    return true;
  }

  function ensureTooltip() {
    if (state.tooltip) return state.tooltip;
    var tooltip = document.createElement('div');
    tooltip.className = 'mm-product-compare-tooltip';
    tooltip.setAttribute('role', 'tooltip');
    tooltip.hidden = true;
    document.body.appendChild(tooltip);
    state.tooltip = tooltip;
    return tooltip;
  }

  function showCompareTooltip(target) {
    var text = target.getAttribute('data-product-compare-tooltip') || target.getAttribute('aria-label') || '';
    if (!text) return;
    var tooltip = ensureTooltip();
    state.tooltipTarget = target;
    tooltip.textContent = text;
    tooltip.hidden = false;
    positionCompareTooltip();
  }

  function hideCompareTooltip() {
    if (state.tooltip) state.tooltip.hidden = true;
    state.tooltipTarget = null;
  }

  function positionCompareTooltip() {
    var tooltip = state.tooltip;
    var target = state.tooltipTarget;
    if (!tooltip || tooltip.hidden || !target || !target.isConnected) return;
    if (typeof target.matches === 'function' && !target.matches(':hover')) {
      hideCompareTooltip();
      return;
    }

    var rect = target.getBoundingClientRect();
    var tooltipRect = tooltip.getBoundingClientRect();
    var left = rect.left + (rect.width / 2) - (tooltipRect.width / 2);
    var top = rect.bottom + 8;

    left = Math.max(8, Math.min(left, window.innerWidth - tooltipRect.width - 8));
    if (top + tooltipRect.height + 8 > window.innerHeight) {
      top = rect.top - tooltipRect.height - 8;
    }
    top = Math.max(8, top);

    tooltip.style.left = left + 'px';
    tooltip.style.top = top + 'px';
  }

  function openCompare(seed, options) {
    ensureModal();
    hideCompareTooltip();
    state.lastFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    document.body.classList.add('mm-product-compare-open');
    state.modal.hidden = false;
    state.modal.setAttribute('aria-hidden', 'false');
    setSideProduct('left', seed);
    if (!state.right) renderSide('right');
    focusSide((options && options.focusSide) || 'right');
  }

  function closeCompare() {
    if (!state.modal) return;
    closeGalleryViewer({ restoreFocus: false });
    state.modal.hidden = true;
    state.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mm-product-compare-open');
    SIDES.forEach(hideSearchResults);
    if (state.lastFocus && state.lastFocus.isConnected) {
      state.lastFocus.focus();
    }
  }

  function ensureModal() {
    if (state.modal) return state.modal;

    var existing = document.getElementById(MODAL_ID);
    if (existing) {
      state.modal = existing;
      return existing;
    }

    var modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'mm-product-compare';
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="mm-product-compare__overlay" data-product-compare-close></div>' +
      '<div class="mm-product-compare__dialog" role="dialog" aria-modal="true" aria-labelledby="mm-product-compare-title">' +
        '<header class="mm-product-compare__header">' +
          '<h2 class="mm-product-compare__title" id="mm-product-compare-title">Compare products</h2>' +
          '<button class="mm-product-compare__close" type="button" aria-label="Close compare" data-product-compare-close>&times;</button>' +
        '</header>' +
        '<div class="mm-product-compare__body">' +
          renderSideShell('left') +
          renderSideShell('right') +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    state.modal = modal;
    SIDES.forEach(renderSide);
    return modal;
  }

  function renderSideShell(side) {
    var label = SIDE_LABELS[side];
    return (
      '<section class="mm-product-compare__side" data-product-compare-side="' + side + '">' +
        '<div class="mm-product-compare__side-header">' +
          '<span class="mm-product-compare__side-label">' + label + '</span>' +
          '<div class="mm-product-compare__search-wrap">' +
            '<label class="visually-hidden" for="mm-product-compare-search-' + side + '">Search ' + label + '</label>' +
            '<input class="mm-product-compare__search" id="mm-product-compare-search-' + side + '" type="search" autocomplete="off" placeholder="Search product" data-side="' + side + '" data-product-compare-search-input>' +
            '<div class="mm-product-compare__results" role="listbox" data-side="' + side + '" data-product-compare-search-results hidden></div>' +
          '</div>' +
        '</div>' +
        '<div class="mm-product-compare__content" data-side="' + side + '" data-product-compare-content></div>' +
      '</section>'
    );
  }

  function renderSide(side) {
    ensureModal();
    var slot = state.modal.querySelector('[data-product-compare-content][data-side="' + side + '"]');
    if (!slot) return;
    var product = state[side];

    if (!product) {
      slot.innerHTML = '<div class="mm-product-compare__empty">Search for a product</div>';
      return;
    }

    if (product.loading) {
      slot.innerHTML = '<div class="mm-product-compare__loading">Loading ' + escapeHtml(product.title || 'product') + '</div>';
      return;
    }

    var traits = extractTraits(product);
    var title = escapeHtml(product.title || 'Product');
    var titleHtml = product.url
      ? '<a href="' + escapeAttribute(product.url) + '">' + title + '</a>'
      : title;
    var variantId = getProductVariantId(product);

    slot.innerHTML =
      '<article class="mm-product-compare__product">' +
        renderGallery(product) +
        renderProductHeading(product, titleHtml, variantId) +
        renderVariantSelector(product, side) +
        renderProductActions(product) +
        renderTraits(traits) +
        '<div class="mm-product-compare__description">' + renderDescription(product.descriptionText, traits) + '</div>' +
      '</article>';
    initializeWishlistCards(slot);
    initializeRestockCards(slot);
  }

  function renderGallery(product) {
    var images = normalizeImages(product.images || []);
    if (!images.length && product.image) {
      images = [product.image];
    }
    if (!images.length) {
      return '<div class="mm-product-compare__gallery"><figure class="mm-product-compare__image"><span class="mm-product-compare__image-placeholder"></span></figure></div>';
    }

    return (
      '<div class="mm-product-compare__gallery" aria-label="' + escapeAttribute(product.title || 'Product') + ' images">' +
        images.slice(0, 8).map(function (src, index) {
          var alt = product.title || 'Product image';
          return (
            '<figure class="mm-product-compare__image">' +
              '<button class="mm-product-compare__image-button" type="button" data-product-compare-gallery-open data-image-src="' + escapeAttribute(src) + '" data-image-alt="' + escapeAttribute(alt) + '" aria-label="View larger image of ' + escapeAttribute(alt) + '">' +
                '<img src="' + escapeAttribute(src) + '" alt="' + escapeAttribute(alt) + '" loading="' + (index === 0 ? 'eager' : 'lazy') + '">' +
              '</button>' +
            '</figure>'
          );
        }).join('') +
      '</div>'
    );
  }

  function renderProductHeading(product, titleHtml, variantId) {
    return (
      '<div class="mm-product-compare__product-heading">' +
        '<h3 class="mm-product-compare__product-title">' + titleHtml + '</h3>' +
        renderWishlistAction(product, variantId) +
      '</div>'
    );
  }

  function openGalleryViewer(trigger) {
    var src = trigger && trigger.getAttribute('data-image-src');
    if (!src) return;
    var alt = trigger.getAttribute('data-image-alt') || 'Product image';
    var viewer = ensureGalleryViewer();
    var image = viewer.querySelector('[data-product-compare-gallery-viewer-image]');
    var caption = viewer.querySelector('[data-product-compare-gallery-viewer-caption]');
    if (image) {
      image.setAttribute('src', src);
      image.setAttribute('alt', alt);
    }
    if (caption) caption.textContent = alt;
    state.galleryViewerLastFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    viewer.hidden = false;
    viewer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mm-product-compare-gallery-open');
    window.setTimeout(function () {
      var closeButton = viewer.querySelector('[data-product-compare-gallery-close-button]');
      if (closeButton) closeButton.focus();
    }, 0);
  }

  function closeGalleryViewer(options) {
    if (!state.galleryViewer || state.galleryViewer.hidden) return;
    var restoreFocus = !options || options.restoreFocus !== false;
    var image = state.galleryViewer.querySelector('[data-product-compare-gallery-viewer-image]');
    state.galleryViewer.hidden = true;
    state.galleryViewer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mm-product-compare-gallery-open');
    if (image) {
      image.removeAttribute('src');
      image.setAttribute('alt', '');
    }
    if (restoreFocus && state.galleryViewerLastFocus && state.galleryViewerLastFocus.isConnected) {
      state.galleryViewerLastFocus.focus();
    }
    state.galleryViewerLastFocus = null;
  }

  function ensureGalleryViewer() {
    if (state.galleryViewer) return state.galleryViewer;
    var viewer = document.createElement('div');
    viewer.className = 'mm-product-compare-gallery-viewer';
    viewer.hidden = true;
    viewer.setAttribute('aria-hidden', 'true');
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    viewer.setAttribute('aria-label', 'Product image viewer');
    viewer.setAttribute('data-product-compare-gallery-viewer', '');
    viewer.innerHTML =
      '<div class="mm-product-compare-gallery-viewer__backdrop" data-product-compare-gallery-close></div>' +
      '<figure class="mm-product-compare-gallery-viewer__figure">' +
        '<img class="mm-product-compare-gallery-viewer__image" alt="" data-product-compare-gallery-viewer-image>' +
        '<figcaption class="mm-product-compare-gallery-viewer__caption" data-product-compare-gallery-viewer-caption></figcaption>' +
      '</figure>' +
      '<button class="mm-product-compare-gallery-viewer__close" type="button" aria-label="Close image viewer" data-product-compare-gallery-close data-product-compare-gallery-close-button>&times;</button>';
    document.body.appendChild(viewer);
    state.galleryViewer = viewer;
    return viewer;
  }

  function renderTraits(traits) {
    return (
      '<div class="mm-product-compare__traits">' +
        traits.map(function (trait) {
          var keyClass = trait.key ? ' mm-product-compare__trait--' + escapeAttribute(trait.key) : '';
          var missingClass = trait.missing ? ' mm-product-compare__trait--missing' : '';
          return (
            '<div class="mm-product-compare__trait' + keyClass + missingClass + '">' +
              '<span class="mm-product-compare__trait-label">' + escapeHtml(trait.label) + '</span>' +
              '<span class="mm-product-compare__trait-value">' + renderTraitValue(trait) + '</span>' +
            '</div>'
          );
        }).join('') +
      '</div>'
    );
  }

  function renderTraitValue(trait) {
    if (!trait || trait.missing) return escapeHtml(trait && trait.value || 'Not found');
    if (trait.key === 'zone') return renderZoneTraitValue(trait.value);
    if (trait.key === 'colors') return renderColorTraitValue(trait.value);
    return escapeHtml(trait.value);
  }

  function renderZoneTraitValue(value) {
    var label = normalizeSpaces(value || '');
    if (!label) return '';
    return (
      '<a class="mm-product-compare__zone-link" href="' + escapeAttribute(USDA_ZONE_MAP_URL) + '" target="_blank" rel="noopener noreferrer" aria-label="Open USDA Plant Hardiness Zone Map for ' + escapeAttribute(label) + '">' +
        escapeHtml(label) +
      '</a>'
    );
  }

  function renderColorTraitValue(value) {
    var colors = unique(findColors(value || '')).slice(0, 8);
    var swatches = colors.map(renderColorSwatch).filter(Boolean);
    if (!swatches.length) return escapeHtml(value);
    return (
      '<span class="mm-product-compare__color-summary">' + escapeHtml(value) + '</span>' +
      '<span class="mm-product-compare__color-list" aria-label="Detected colors">' + swatches.join('') + '</span>'
    );
  }

  function renderColorSwatch(color) {
    var swatch = getColorSwatch(color);
    if (!swatch) return '';
    var style = 'background: ' + swatch.background + '; color: ' + swatch.text + ';';
    if (swatch.border) style += ' border-color: ' + swatch.border + ';';
    return '<span class="mm-product-compare__color-chip" style="' + escapeAttribute(style) + '">' + escapeHtml(color) + '</span>';
  }

  function getColorSwatch(color) {
    var key = String(color || '').toLowerCase().replace(/[^a-z]/g, '');
    if (!key) return null;
    return COLOR_SWATCHES[key] || null;
  }

  function renderVariantSelector(product, side) {
    if (!isProductAvailable(product)) return '';
    var variants = getAvailableSizeVariants(product);
    if (!variants.length) return '';
    var selectedVariantId = getProductVariantId(product);
    var selectedAvailable = variants.some(function (variant) {
      return variant.id === selectedVariantId;
    });
    if (!selectedAvailable) selectedVariantId = variants[0].id;

    return (
      '<label class="mm-product-compare__size-field">' +
        '<span class="mm-product-compare__size-label">Size</span>' +
        '<select class="mm-product-compare__size-select" data-side="' + escapeAttribute(side) + '" data-product-compare-size-select>' +
          variants.map(function (variant) {
            return (
              '<option value="' + escapeAttribute(variant.id) + '"' + (variant.id === selectedVariantId ? ' selected' : '') + '>' +
                escapeHtml(formatVariantTitle(variant)) +
              '</option>'
            );
          }).join('') +
        '</select>' +
      '</label>'
    );
  }

  function renderProductActions(product) {
    var variantId = getProductVariantId(product);
    var productUrl = product.url || (product.handle ? '/products/' + encodeURIComponent(product.handle) : '#');
    var disabledAttr = variantId ? '' : ' disabled aria-disabled="true"';
    var available = isProductAvailable(product);
    var commonAttrs =
      ' data-product-compare-action-product="' + escapeAttribute(product.handle || product.id || '') + '"' +
      ' data-product-title="' + escapeAttribute(product.title || 'Product') + '"' +
      ' data-variant-id="' + escapeAttribute(variantId || '') + '"';
    var primaryActions = available
      ? (
        '<button class="mm-product-compare__action productitem--action-trigger productitem--action-atc productitem--action-atc-text neumorphic-btn" type="button" aria-label="Add to Cart" data-product-compare-action="cart"' + commonAttrs + disabledAttr + '>' +
          '<span class="atc-button--icon atc-button--text-icon">' +
            '<span class="mm-product-compare__label-full">Add to Cart</span>' +
            '<span class="mm-product-compare__label-short" aria-hidden="true">Cart</span>' +
          '</span>' +
        '</button>' +
        '<button class="mm-product-compare__action productitem--action-trigger productitem--action-atc productitem--action-buy neumorphic-btn productitem--buy-btn" type="button" aria-label="Buy now" data-product-compare-action="buy"' + commonAttrs + disabledAttr + '>' +
          '<span class="atc-button--icon atc-button--text-icon">' +
            '<span class="mm-product-compare__label-full">Buy now</span>' +
            '<span class="mm-product-compare__label-short" aria-hidden="true">Buy</span>' +
          '</span>' +
        '</button>'
      )
      : renderRestockAction(product, variantId);
    var primaryClass = available
      ? 'mm-product-compare__primary-actions'
      : 'mm-product-compare__primary-actions mm-product-compare__primary-actions--notify';

    return (
      '<div class="mm-product-compare__actions">' +
        '<div class="' + primaryClass + '">' + primaryActions + '</div>' +
        '<div class="mm-product-compare__secondary-actions">' +
          '<a class="mm-product-compare__action mm-product-compare__page-link productitem--action-trigger neumorphic-btn" href="' + escapeAttribute(productUrl) + '" aria-label="Go to product page">' +
            '<span class="atc-button--icon atc-button--text-icon">' +
              '<span class="mm-product-compare__label-full">Go to product page</span>' +
              '<span class="mm-product-compare__label-short" aria-hidden="true">Details</span>' +
            '</span>' +
          '</a>' +
        '</div>' +
      '</div>'
    );
  }

  function renderRestockAction(product, variantId) {
    var productGid = getProductGid(product);
    var loginUrl = '/account/login?return_url=' + encodeURIComponent(product.url || window.location.pathname + window.location.search);
    return (
      '<div class="mm-product-compare__restock mm-restock-cta mm-restock-cta--compare" ' +
        'data-mm-restock-cta ' +
        'data-product-gid="' + escapeAttribute(productGid) + '" ' +
        'data-variant-id="' + escapeAttribute(variantId || '') + '" ' +
        'data-app-proxy-base="/apps/garden" ' +
        'data-login-url="' + escapeAttribute(loginUrl) + '" ' +
        'data-success-text="You&apos;ll be the first to know!" ' +
        'data-removed-text="Restock notification removed." ' +
        'data-login-text="Please sign in to get notified when this plant is back in stock." ' +
        'data-error-text="Unable to save your alert. Please try again." ' +
        'data-restock-request-source="product-compare" ' +
        'data-restock-trace-surface="product-compare" ' +
        'data-restock-trace-component="mm-product-compare">' +
        '<button class="mm-product-compare__action mm-product-compare__notify productitem--action-trigger productitem--action-atc productitem--action-notify mm-restock-cta__button neumorphic-btn" type="button" ' +
          'data-mm-restock-btn ' +
          'data-default-text="Notify me" ' +
          'data-subscribed-text="Alert set" ' +
          'aria-label="Notify me when available" ' +
          'aria-pressed="false">' +
          '<span class="atc-button--icon" aria-hidden="true">' +
            '<span class="restock-bell restock-bell--outline"><i class="fi fi-rr-bell" aria-hidden="true"></i></span>' +
            '<span class="restock-bell restock-bell--filled"><i class="fi fi-sr-bell" aria-hidden="true"></i></span>' +
          '</span>' +
          '<span data-mm-restock-label>Notify me</span>' +
        '</button>' +
        '<p class="mm-product-compare__restock-status mm-restock-cta__status" data-mm-restock-status hidden></p>' +
      '</div>'
    );
  }

  function renderWishlistAction(product, variantId) {
    return (
      '<div class="mm-product-compare__like" data-wishlist-card ' +
        'data-product-id="' + escapeAttribute(product.id || '') + '" ' +
        'data-variant-id="' + escapeAttribute(variantId || '') + '" ' +
        'data-product-handle="' + escapeAttribute(product.handle || '') + '" ' +
        'data-product-title="' + escapeAttribute(product.title || '') + '" ' +
        'data-product-vendor="' + escapeAttribute(product.vendor || '') + '" ' +
        'data-product-type="' + escapeAttribute(product.productType || '') + '" ' +
        'data-product-tags="' + escapeAttribute((product.tags || []).join(',')) + '" ' +
        'data-product-price="' + escapeAttribute(product.price || '') + '" ' +
        'data-product-currency="' + escapeAttribute(product.currency || '') + '" ' +
        'data-product-image="' + escapeAttribute(product.image || '') + '" ' +
        'data-app-proxy-base="/apps/garden" ' +
        'data-default-list-name="Wishlist">' +
        '<button class="wl-gallery-heart wl-gallery-heart--card mm-product-compare__like-button" type="button" aria-label="Add ' + escapeAttribute(product.title || 'product') + ' to Wishlist" aria-pressed="false" data-gallery-heart-btn>' +
          '<div class="wl-gallery-heart__icon-wrapper">' +
            '<svg class="wl-gallery-heart__icon wl-gallery-heart__icon--empty" viewBox="0 0 24 24" aria-hidden="true" fill="none">' +
              '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
            '</svg>' +
            '<svg class="wl-gallery-heart__icon wl-gallery-heart__icon--filled" viewBox="0 0 24 24" aria-hidden="true">' +
              '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="currentColor"/>' +
            '</svg>' +
            '<span class="wl-gallery-heart__burst" aria-hidden="true"></span>' +
          '</div>' +
          '<div class="wl-gallery-heart__spinner" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" opacity="0.25"/><path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round"/></svg>' +
          '</div>' +
        '</button>' +
      '</div>'
    );
  }

  function initializeWishlistCards(root) {
    if (!root || !root.querySelector('[data-wishlist-card]')) return;
    window.setTimeout(function () {
      document.dispatchEvent(new CustomEvent('mm:cards:added'));
    }, 0);
  }

  function initializeRestockCards(root) {
    if (!root || !root.querySelector('[data-mm-restock-cta]')) return;
    window.setTimeout(function () {
      if (window.RestockCard && typeof window.RestockCard.init === 'function') {
        window.RestockCard.init(root);
      }
    }, 0);
  }

  function renderDescription(text, traits) {
    var description = normalizeDisplayText(text || '');
    if (!description) return '<p>No description available.</p>';
    return description
      .split(/\n{2,}/)
      .map(function (paragraph) {
        var trimmed = normalizeSpaces(paragraph);
        if (!trimmed) return '';
        return '<p>' + highlightText(trimmed, traits) + '</p>';
      })
      .filter(Boolean)
      .join('');
  }

  function setSideProduct(side, seed) {
    var normalizedSeed = normalizeProduct(seed || {});
    if (!normalizedSeed.handle) return;
    state[side] = Object.assign({}, normalizedSeed, { loading: true });
    renderSide(side);

    hydrateProduct(normalizedSeed)
      .then(function (product) {
        state[side] = product || normalizedSeed;
        renderSide(side);
      })
      .catch(function () {
        state[side] = normalizedSeed;
        renderSide(side);
      });
  }

  function handleProductAction(button) {
    var mode = button.getAttribute('data-product-compare-action');
    var variantId = normalizeVariantId(button.getAttribute('data-variant-id'));
    if (!variantId) {
      window.alert('Unable to add this product. Please open the product page to choose a size.');
      return;
    }

    if (mode === 'buy') {
      buyVariantNow(button, variantId);
      return;
    }

    addVariantToCart(button, variantId);
  }

  function addVariantToCart(button, variantId) {
    setActionLoading(button, true);
    return addCartItem(variantId, { triggerButton: button, openDrawer: true })
      .then(function () {
        setActionFeedback(button, 'Added');
      })
      .catch(function (error) {
        window.alert(error && error.message ? error.message : 'Unable to add item to cart. Please try again.');
      })
      .finally(function () {
        setActionLoading(button, false);
      });
  }

  function buyVariantNow(button, variantId) {
    if (window.MrMapleSingleItemCheckout && typeof window.MrMapleSingleItemCheckout.start === 'function') {
      window.MrMapleSingleItemCheckout.start({
        source: 'compare-modal',
        item: { id: variantId, quantity: 1 },
        setLoading: function (isLoading) {
          setActionLoading(button, isLoading);
        },
      }).catch(function (error) {
        window.alert(error && error.message ? error.message : 'Unable to start checkout. Please try again.');
      });
      return;
    }

    setActionLoading(button, true);
    addCartItem(variantId, { triggerButton: button, openDrawer: false })
      .then(function () {
        window.location.href = routePath('checkout');
      })
      .catch(function (error) {
        window.alert(error && error.message ? error.message : 'Unable to start checkout. Please try again.');
      })
      .finally(function () {
        setActionLoading(button, false);
      });
  }

  function addCartItem(variantId, options) {
    var cartOptions = options || {};

    if (window.MiniCart && typeof window.MiniCart.addItem === 'function') {
      return window.MiniCart.addItem({
        variantId: variantId,
        quantity: 1,
        triggerButton: cartOptions.triggerButton || null,
        openDrawer: cartOptions.openDrawer !== false,
        suppressErrorToast: true,
      });
    }

    return fetch(routePath('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
      }),
    }).then(function (response) {
      return response.text().then(function (text) {
        var payload = null;
        try {
          payload = text ? JSON.parse(text) : null;
        } catch (_) {}
        if (!response.ok) {
          var message = payload && (payload.description || payload.message);
          throw new Error(message || 'Unable to add item to cart.');
        }
        dispatchCartUpdate(payload);
        return payload;
      });
    });
  }

  function dispatchCartUpdate(payload) {
    fetch(routePath('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart) {
          window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
        }
      })
      .catch(function () {});

    document.dispatchEvent(new CustomEvent('addToCartFlyout:complete', {
      detail: {
        responseData: payload,
        success: true,
      },
    }));
  }

  function setActionLoading(button, isLoading) {
    if (!button) return;
    button.classList.toggle('processing', Boolean(isLoading));
    button.disabled = Boolean(isLoading);
  }

  function setActionFeedback(button, text) {
    var label = button && button.querySelector('.atc-button--text-icon');
    if (!label) return;
    var original = label.getAttribute('data-original-label') || label.textContent || '';
    if (!label.getAttribute('data-original-label')) {
      label.setAttribute('data-original-label', original);
    }
    label.textContent = text;
    window.setTimeout(function () {
      label.textContent = label.getAttribute('data-original-label') || original;
    }, 1800);
  }

  function hydrateProduct(seed) {
    var handle = normalizeHandle(seed.handle);
    if (!handle) return Promise.resolve(seed);
    var loader = window.MrMapleProductJsonLoader;
    var loadPromise = null;
    var availabilityPromise = null;

    if (loader && typeof loader.loadFull === 'function') {
      loadPromise = loader.loadFull(handle);
    }

    if (loader && typeof loader.loadAvailability === 'function') {
      availabilityPromise = loader.loadAvailability(handle);
    }

    if (!loadPromise && loader && typeof loader.load === 'function') {
      loadPromise = loader.load(handle);
    }

    if (!loadPromise) {
      loadPromise = fetchProductJson(handle);
    }

    return Promise.resolve(loadPromise).then(function (fullProduct) {
      if (!fullProduct && loader && typeof loader.load === 'function') {
        return loader.load(handle);
      }
      return fullProduct;
    }).then(function (fullProduct) {
      return Promise.resolve(availabilityPromise).then(function (availability) {
        var merged = Object.assign({}, seed, fullProduct || {});
        if (availability) {
          merged.available = availability.available;
          if (availability.variantId) {
            merged.variantId = availability.variantId;
          }
        }
        merged.handle = normalizeHandle(merged.handle || seed.handle);
        merged.url = merged.url || seed.url || (merged.handle ? '/products/' + encodeURIComponent(merged.handle) : '');
        return normalizeProduct(merged);
      });
    });
  }

  function fetchProductJson(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.json', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Full product JSON failed');
        return response.json();
      })
      .then(function (payload) {
        return payload && payload.product ? payload.product : payload;
      })
      .catch(function () {
        return fetch('/products/' + encodeURIComponent(handle) + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        }).then(function (response) {
          if (!response.ok) return null;
          return response.json();
        });
      });
  }

  function scheduleProductSearch(side, query) {
    clearTimeout(state.searchTimers[side]);
    var normalized = normalizeSpaces(query || '');
    if (normalized.length < 2) {
      hideSearchResults(side);
      return;
    }
    renderSearchNote(side, 'Searching...');
    state.searchTimers[side] = setTimeout(function () {
      searchProducts(side, normalized);
    }, 220);
  }

  function searchProducts(side, query) {
    if (state.searchControllers[side]) {
      state.searchControllers[side].abort();
    }
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    state.searchControllers[side] = controller;

    fetch(getSuggestJsonUrl(query), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined,
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Search failed');
        return response.json();
      })
      .then(function (payload) {
        var products = getProductsFromSuggestPayload(payload);
        renderSearchResults(side, products);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        renderSearchNote(side, 'No matches found.');
      });
  }

  function getSuggestJsonUrl(query) {
    var routes = window.Theme && window.Theme.routes ? window.Theme.routes : {};
    var base = routes.predictive_search_url || '/search/suggest';
    if (!/\.json(?:\?|$)/.test(base)) {
      base = base.replace(/\/$/, '') + '.json';
    }
    var url = new URL(base, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '8');
    url.searchParams.set('resources[options][unavailable_products]', 'last');
    return url.toString();
  }

  function getProductsFromSuggestPayload(payload) {
    var resources = payload && payload.resources ? payload.resources : {};
    var results = resources.results || resources;
    var products = results.products || payload.products || [];
    return Array.isArray(products) ? products.map(normalizeProduct).filter(function (product) {
      return product.handle;
    }) : [];
  }

  function renderSearchResults(side, products) {
    if (!products.length) {
      renderSearchNote(side, 'No matches found.');
      return;
    }
    var results = getSearchResultsElement(side);
    if (!results) return;
    results.innerHTML = products.map(function (product) {
      var image = product.image || (product.images && product.images[0]) || '';
      var availableAttr = product.available === null || product.available === undefined ? '' : String(product.available);
      return (
        '<button class="mm-product-compare__result" type="button" role="option" data-side="' + side + '" data-product-compare-search-result ' +
          'data-product-id="' + escapeAttribute(product.id || '') + '" ' +
          'data-product-gid="' + escapeAttribute(product.productGid || '') + '" ' +
          'data-variant-id="' + escapeAttribute(getProductVariantId(product) || '') + '" ' +
          'data-product-handle="' + escapeAttribute(product.handle) + '" ' +
          'data-product-title="' + escapeAttribute(product.title) + '" ' +
          'data-product-available="' + escapeAttribute(availableAttr) + '" ' +
          'data-product-average-height-10yr="' + escapeAttribute(product.averageHeight10yr || '') + '" ' +
          'data-product-habit="' + escapeAttribute(product.habit || '') + '" ' +
          'data-product-growth-rate="' + escapeAttribute(product.growthRate || '') + '" ' +
          'data-product-url="' + escapeAttribute(product.url || '') + '" ' +
          'data-product-image="' + escapeAttribute(image) + '" ' +
          'data-product-images="' + escapeAttribute(JSON.stringify(product.images || [])) + '">' +
          (image
            ? '<img src="' + escapeAttribute(image) + '" alt="" loading="lazy">'
            : '<span class="mm-product-compare__result-image"></span>') +
          '<span class="mm-product-compare__result-title">' + escapeHtml(product.title || 'Product') + '</span>' +
        '</button>'
      );
    }).join('');
    results.hidden = false;
  }

  function renderSearchNote(side, text) {
    var results = getSearchResultsElement(side);
    if (!results) return;
    results.innerHTML = '<div class="mm-product-compare__result-note">' + escapeHtml(text) + '</div>';
    results.hidden = false;
  }

  function hideSearchResults(side) {
    var results = getSearchResultsElement(side);
    if (!results) return;
    results.hidden = true;
    results.innerHTML = '';
  }

  function getSearchResultsElement(side) {
    ensureModal();
    return state.modal.querySelector('[data-product-compare-search-results][data-side="' + side + '"]');
  }

  function setSearchValue(side, value) {
    var input = state.modal && state.modal.querySelector('[data-product-compare-search-input][data-side="' + side + '"]');
    if (input) input.value = value || '';
  }

  function focusSide(side) {
    window.setTimeout(function () {
      var input = state.modal && state.modal.querySelector('[data-product-compare-search-input][data-side="' + side + '"]');
      if (input) input.focus();
    }, 0);
  }

  function getProductSeed(element) {
    var source = element.closest('[data-product-compare-card]') || element;
    var dataset = source.dataset || {};
    var images = parseImages(dataset.productImages);
    var handle = normalizeHandle(dataset.productHandle || handleFromUrl(dataset.productUrl || dataset.url || ''));
    return normalizeProduct({
      id: dataset.productId || dataset.id,
      productGid: dataset.productGid || dataset.productAdminGraphqlApiId || '',
      variantId: dataset.variantId,
      handle: handle,
      title: dataset.productTitle || dataset.title || source.getAttribute('aria-label') || '',
      vendor: dataset.productVendor || '',
      product_type: dataset.productType || '',
      tags: dataset.productTags || '',
      price: dataset.productPrice || '',
      currency: dataset.productCurrency || '',
      available: parseBoolean(dataset.productAvailable),
      zones: dataset.productZones || dataset.zones || '',
      minZone: dataset.productMinZone || dataset.minZone || '',
      maxZone: dataset.productMaxZone || dataset.maxZone || '',
      averageHeight10yr: dataset.productAverageHeight10yr || dataset.averageHeight10yr || '',
      habit: dataset.productHabit || dataset.habit || '',
      growthRate: dataset.productGrowthRate || dataset.growthRate || '',
      springColor: dataset.productSpringColor || dataset.springColor || '',
      fallColor: dataset.productFallColor || dataset.fallColor || '',
      bloomColor: dataset.productBloomColor || dataset.bloomColor || '',
      foliageColor: dataset.productFoliageColor || dataset.foliageColor || '',
      url: dataset.productUrl || (handle ? '/products/' + encodeURIComponent(handle) : ''),
      image: dataset.productImage || '',
      images: images,
      description: dataset.productDescription || '',
    });
  }

  function normalizeProduct(product) {
    product = product || {};
    var url = product.url || product.product_url || '';
    var handle = normalizeHandle(product.handle || handleFromUrl(url));
    var title = decodeHtml(stripTags(product.title || product.name || ''));
    var descriptionHtml = product.body_html || product.description || product.body || product.content || '';
    var image = normalizeImage(product.image || product.featured_image || product.featuredImage || product.featured_media);
    var images = normalizeImages(product.images || product.media || []);
    var variants = normalizeVariants(product.variants || []);
    var variantId = normalizeVariantId(product.variantId || product.variant_id || product.selected_variant_id);
    var available = normalizeProductAvailability(product, variants);
    var productGid = getProductGid(product);
    var zones = getProductZone(product);
    var averageHeight10yr = getProductCatalogField(product, 'averageHeight10yr');
    var habit = getProductCatalogField(product, 'habit');
    var growthRate = getProductCatalogField(product, 'growthRate');
    var springColor = getProductCatalogField(product, 'springColor');
    var fallColor = getProductCatalogField(product, 'fallColor');
    var bloomColor = getProductCatalogField(product, 'bloomColor');
    var foliageColor = getProductCatalogField(product, 'foliageColor');
    if (image && images.indexOf(image) === -1) images.unshift(image);
    if (!variantId) {
      var selectedVariant = chooseVariant(variants);
      variantId = selectedVariant && selectedVariant.id ? selectedVariant.id : '';
    }

    return {
      id: product.id || product.product_id || '',
      productGid: productGid,
      available: available,
      zones: zones,
      averageHeight10yr: averageHeight10yr,
      habit: habit,
      growthRate: growthRate,
      springColor: springColor,
      fallColor: fallColor,
      bloomColor: bloomColor,
      foliageColor: foliageColor,
      variantId: variantId,
      handle: handle,
      title: title || (handle ? titleizeHandle(handle) : 'Product'),
      vendor: product.vendor || '',
      productType: product.product_type || product.productType || product.type || '',
      tags: normalizeTags(product.tags),
      price: product.price || product.price_min || '',
      currency: product.currency || '',
      variants: variants,
      url: url || (handle ? '/products/' + encodeURIComponent(handle) : ''),
      image: image || images[0] || '',
      images: images,
      descriptionHtml: descriptionHtml,
      descriptionText: cleanDescriptionText(htmlToText(descriptionHtml)),
    };
  }

  function normalizeVariants(variants) {
    if (!Array.isArray(variants)) return [];
    return variants.map(function (variant) {
      var id = normalizeVariantId(variant && (variant.id || variant.variant_id));
      if (!id) return null;
      return {
        id: id,
        title: variant.title || variant.name || [variant.option1, variant.option2, variant.option3].filter(Boolean).join(' / ') || '',
        available: normalizeVariantAvailability(variant),
        price: variant.price || '',
      };
    }).filter(Boolean);
  }

  function chooseVariant(variants) {
    if (!Array.isArray(variants) || !variants.length) return null;
    return variants.find(function (variant) {
      return variant && variant.available === true;
    }) || variants.find(function (variant) {
      return variant && variant.available !== false;
    }) || variants[0];
  }

  function getProductVariantId(product) {
    var explicitVariantId = normalizeVariantId(product && product.variantId);
    if (explicitVariantId) {
      var explicitVariant = findVariantById(product && product.variants, explicitVariantId);
      if (!explicitVariant || explicitVariant.available !== false) return explicitVariantId;
    }
    var variant = chooseVariant(product && product.variants);
    return variant ? variant.id : '';
  }

  function findVariantById(variants, variantId) {
    var normalizedId = normalizeVariantId(variantId);
    if (!normalizedId || !Array.isArray(variants)) return null;
    return variants.find(function (variant) {
      return variant && normalizeVariantId(variant.id) === normalizedId;
    }) || null;
  }

  function getAvailableSizeVariants(product) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];
    return variants.filter(function (variant) {
      return variant && variant.id && variant.available === true && isDisplaySizeVariant(variant);
    });
  }

  function isDisplaySizeVariant(variant) {
    var title = formatVariantTitle(variant);
    return Boolean(title) && !/^default\s+title$/i.test(title);
  }

  function formatVariantTitle(variant) {
    return normalizeSpaces(variant && variant.title || '');
  }

  function normalizeProductAvailability(product, variants) {
    var explicit = parseBoolean(product && (product.available !== undefined ? product.available : product.availableForSale));
    if (explicit !== null) return explicit;

    if (Array.isArray(variants) && variants.length) {
      var knownVariants = variants.filter(function (variant) {
        return variant && variant.available !== null;
      });
      if (knownVariants.length) {
        return knownVariants.some(function (variant) {
          return variant.available === true;
        });
      }
    }

    return null;
  }

  function normalizeVariantAvailability(variant) {
    if (!variant) return null;
    var available = parseBoolean(variant.available);
    if (available !== null) return available;
    return parseBoolean(variant.availableForSale);
  }

  function isProductAvailable(product) {
    if (!product) return true;
    if (product.available === false) return false;
    if (product.available === true) return true;

    var variants = Array.isArray(product.variants) ? product.variants : [];
    var knownVariants = variants.filter(function (variant) {
      return variant && variant.available !== null;
    });
    if (knownVariants.length) {
      return knownVariants.some(function (variant) {
        return variant.available === true;
      });
    }

    return true;
  }

  function getProductGid(product) {
    var source = product && (
      product.productGid ||
      product.product_gid ||
      product.admin_graphql_api_id ||
      product.adminGraphqlApiId ||
      product.gid ||
      product.id ||
      product.product_id
    );
    if (!source) return '';
    var value = String(source).trim();
    if (!value) return '';
    if (/^gid:\/\/shopify\/Product\//i.test(value)) return value;
    var numeric = value.replace(/[^0-9]/g, '');
    return numeric ? 'gid://shopify/Product/' + numeric : '';
  }

  function getProductZone(product) {
    var explicit = getProductCatalogField(product, 'zones');
    var explicitTrait = extractZoneFromSource(explicit ? 'Zones ' + explicit : '', 4);
    if (explicitTrait) return explicitTrait.value;

    var minZone = getProductCatalogField(product, 'minZone');
    var maxZone = getProductCatalogField(product, 'maxZone');
    var min = formatZoneNumber(minZone);
    var max = formatZoneNumber(maxZone);
    if (min && max) return min === max ? 'Zone ' + min : 'Zones ' + min + '-' + max;
    if (min) return 'Zone ' + min;
    if (max) return 'Zone ' + max;
    return '';
  }

  function getProductCatalogField(product, field) {
    if (!product) return '';
    var candidates = [];
    var keys = CATALOG_DETAIL_KEYS[field] || [field];
    keys.forEach(function (key) {
      candidates.push(product[key]);
    });

    var catalogDetails = product.catalogDetails || product.catalog_details || product.catalog || null;
    if (catalogDetails && typeof catalogDetails === 'object') {
      keys.forEach(function (key) {
        candidates.push(catalogDetails[key]);
      });
    }

    METAFIELD_KEYS.forEach(function (meta) {
      if (meta.field !== field) return;
      candidates.push(product[meta.key]);
      candidates.push(getMetafieldValue(product, meta.namespace, meta.key));
      candidates.push(getMetafieldValue(product, null, meta.key));
    });

    for (var i = 0; i < candidates.length; i += 1) {
      var value = normalizeCatalogValue(candidates[i]);
      if (value) return value;
    }

    return '';
  }

  function getMetafieldValue(product, namespace, key) {
    var metafields = product && product.metafields;
    if (!metafields) return '';

    if (Array.isArray(metafields)) {
      for (var i = 0; i < metafields.length; i += 1) {
        var metafield = metafields[i] || {};
        if (namespace && metafield.namespace !== namespace) continue;
        if (metafield.key === key) return normalizeCatalogValue(metafield.value);
      }
      return '';
    }

    if (namespace && metafields[namespace]) {
      return normalizeCatalogValue(metafields[namespace][key]);
    }

    return normalizeCatalogValue(metafields[key]);
  }

  function normalizeCatalogValue(value) {
    if (value === null || value === undefined) return '';
    if (typeof value === 'object') {
      if (value.value !== undefined) return normalizeCatalogValue(value.value);
      if (value.label !== undefined) return normalizeCatalogValue(value.label);
      return '';
    }
    return normalizeSpaces(value);
  }

  function normalizeImages(value) {
    var list = [];
    if (!value) return list;
    if (typeof value === 'string') {
      if (/^\s*\[/.test(value)) {
        list = parseImages(value);
      } else {
        list = [value];
      }
    } else if (Array.isArray(value)) {
      list = value.map(normalizeImage);
    } else {
      list = [normalizeImage(value)];
    }
    return Array.from(new Set(list.filter(Boolean)));
  }

  function normalizeImage(value) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value.src || value.url || value.preview_image && value.preview_image.src || value.previewImage && value.previewImage.url || '';
  }

  function parseImages(value) {
    if (!value) return [];
    try {
      var parsed = JSON.parse(value);
      return normalizeImages(parsed);
    } catch (_) {
      return String(value).split(',').map(function (item) {
        return item.trim();
      }).filter(Boolean);
    }
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) return tags.map(String).map(normalizeSpaces).filter(Boolean);
    if (!tags) return [];
    return String(tags).split(',').map(normalizeSpaces).filter(Boolean);
  }

  function extractTraits(product) {
    var text = product.descriptionText || htmlToText(product.descriptionHtml || '');
    var source = normalizeSpaces([
      product.title,
      product.zones,
      product.averageHeight10yr,
      product.habit,
      product.growthRate,
      product.springColor,
      product.fallColor,
      product.bloomColor,
      product.foliageColor,
      text,
      (product.tags || []).join(' '),
    ].join(' '));
    var height = extractHeight(text, product.averageHeight10yr);
    var habit = extractHabit(product, text);
    var traits = {
      zone: extractZone(product, text, product.tags || []),
      height: height,
      habit: habit,
      colors: extractColors(product, source, text),
      growth: extractGrowth(product, text, height, habit),
    };

    return TRAIT_ORDER.map(function (traitMeta) {
      var trait = traits[traitMeta.key] || {};
      return {
        key: traitMeta.key,
        label: traitMeta.label,
        value: trait.value || 'Not found',
        evidence: trait.evidence || [],
        missing: !trait.value,
      };
    });
  }

  function extractZone(product, text, tags) {
    var directZone = extractProductZone(product);
    if (directZone) return directZone;

    var sources = [text, (tags || []).join(' ')];

    for (var i = 0; i < sources.length; i += 1) {
      var trait = extractZoneFromSource(sources[i], 4);
      if (trait) return trait;
    }
    return null;
  }

  function extractProductZone(product) {
    var zone = product && product.zones;
    if (!zone) return null;
    var value = normalizeSpaces(zone);
    var parsed = extractZoneFromSource(/^zones?\b/i.test(value) ? value : 'Zones ' + value, 4);
    if (parsed) return parsed;
    return {
      value: value,
      evidence: [{ text: value, key: 'zone', priority: 4 }],
    };
  }

  function extractZoneFromSource(source, priority) {
    var zoneNumber = '((?:1[0-3]|[0-9])(?:\\s*[abAB]|\\.\\d)?)';
    var zonePrefix = '\\b(?:usda\\s*)?(?:hardiness\\s*)?zones?\\s*(?:[:#])?\\s*';
    var rangePattern = new RegExp(zonePrefix + zoneNumber + '\\s*(?:-|\\u2013|\\u2014|to|through|thru)\\s*' + zoneNumber, 'i');
    var singlePattern = new RegExp(zonePrefix + zoneNumber, 'i');
    var text = source || '';
    var range = text.match(rangePattern);
    if (range) {
      return {
        value: 'Zones ' + formatZoneNumber(range[1]) + '-' + formatZoneNumber(range[2]),
        evidence: [{ text: range[0], key: 'zone', priority: priority || 3 }],
      };
    }
    var single = text.match(singlePattern);
    if (single) {
      return {
        value: 'Zone ' + formatZoneNumber(single[1]),
        evidence: [{ text: single[0], key: 'zone', priority: priority || 3 }],
      };
    }
    return null;
  }

  function extractHeight(text, explicitAverageHeight) {
    var explicitHeight = extractAverageHeight(explicitAverageHeight);
    if (explicitHeight) return explicitHeight;

    var sentences = splitSentences(text);
    var priority = sentences.filter(function (sentence) {
      return /\b(?:\d+\s*(?:-| )?\s*years?|ten\s+years?|after\s+\d+|in\s+\d+|at\s+\d+)\b/i.test(sentence);
    }).concat(sentences);
    var feetNumber = '\\d+(?:\\s*\\.\\s*\\d+)?';
    var feetRange = '(?:' + feetNumber + '\\s*(?:-|\\u2013|\\u2014|to)\\s*' + feetNumber + ')';
    var heightValue = '(' + feetRange + '|' + feetNumber + ')';
    var tallPattern = new RegExp('\\b' + heightValue + "\\s*(ft\\.?|feet|foot|')\\s*(tall|high|in height)\\b", 'i');
    var loosePattern = new RegExp('\\b' + heightValue + "\\s*(ft\\.?|feet|foot|')\\b", 'i');

    for (var i = 0; i < priority.length; i += 1) {
      var sentence = priority[i];
      var match = sentence.match(tallPattern) || (/\b(?:height|reaches|reach|grows?|matures?|10\s*(?:-| )?\s*years?)\b/i.test(sentence) ? sentence.match(loosePattern) : null);
      if (match) {
        var range = parseFeetRange(match[1]);
        if (!range) continue;
        var years = extractYearBasis(sentence) || 10;
        var normalizedRange = normalizeHeightRangeToTenYears(range, years);
        var value = formatFeetRange(normalizedRange) + ' ft in 10 years';
        return {
          value: value,
          normalizedAverage: (normalizedRange.min + normalizedRange.max) / 2,
          sourceYears: years,
          evidence: [{ text: buildHeightEvidence(sentence, match), key: 'height', priority: 3 }],
        };
      }
    }
    return null;
  }

  function extractAverageHeight(value) {
    var source = normalizeSpaces(value || '');
    if (!source) return null;

    var feetNumber = '\\d+(?:\\s*\\.\\s*\\d+)?';
    var feetRange = '(?:' + feetNumber + '\\s*(?:-|\\u2013|\\u2014|to)\\s*' + feetNumber + ')';
    var heightValue = '(' + feetRange + '|' + feetNumber + ')';
    var pattern = new RegExp('\\b' + heightValue + "\\s*(?:ft\\.?|feet|foot|')?\\b", 'i');
    var match = source.match(pattern);
    if (!match) return null;

    var range = parseFeetRange(match[1]);
    if (!range) return null;

    return {
      value: formatFeetRange(range) + ' ft in 10 years',
      normalizedAverage: (range.min + range.max) / 2,
      sourceYears: 10,
      evidence: [{ text: match[0], key: 'height', priority: 4 }],
    };
  }

  function extractHabit(product, text) {
    var directHabit = normalizeHabit(product && product.habit);
    if (directHabit) {
      return {
        value: directHabit,
        evidence: [{ text: product.habit, key: 'habit', priority: 4 }],
      };
    }

    return extractHabitText([
      text,
      product && product.title,
      product && Array.isArray(product.tags) ? product.tags.join(' ') : '',
    ].filter(Boolean).join('. '));
  }

  function extractHabitText(text) {
    var sentences = splitSentences(text);
    var priority = sentences.filter(function (sentence) {
      return HABIT_CONTEXT_PATTERN.test(sentence);
    });
    var fallback = sentences.filter(function (sentence) {
      return hasHabitMatch(sentence) && HABIT_PLANT_CONTEXT_PATTERN.test(sentence);
    });
    var candidates = priority.concat(fallback);
    var matches = [];

    for (var i = 0; i < candidates.length; i += 1) {
      addHabitMatches(matches, candidates[i]);
    }

    if (!matches.length) return null;
    return {
      value: matches.map(function (match) {
        return match.value;
      }).join(', '),
      evidence: matches.map(function (match) {
        return { text: match.text, key: 'habit', priority: 3 };
      }),
    };
  }

  function addHabitMatches(matches, value) {
    findHabitMatches(value).forEach(function (match) {
      var exists = matches.some(function (item) {
        return item.value === match.value;
      });
      if (!exists) matches.push(match);
    });
  }

  function hasHabitMatch(value) {
    return findHabitMatches(value).length > 0;
  }

  function findHabitMatches(value) {
    var source = normalizeSpaces(value || '');
    if (!source) return [];
    var matches = [];

    for (var i = 0; i < HABIT_TERMS.length; i += 1) {
      var term = HABIT_TERMS[i];
      for (var j = 0; j < term.aliases.length; j += 1) {
        var alias = term.aliases[j];
        var aliasPattern = escapeRegExp(alias).replace(/\s+/g, '\\s+');
        var pattern = new RegExp('(^|[^a-z0-9])(' + aliasPattern + ')(?=$|[^a-z0-9])', 'i');
        var match = source.match(pattern);
        if (match) {
          matches.push({
            value: term.label,
            text: match[2],
            index: match.index + match[1].length,
          });
          break;
        }
      }
    }

    return matches.sort(function (a, b) {
      return a.index - b.index;
    });
  }

  function extractGrowth(product, text, heightTrait, habitTrait) {
    var directGrowth = extractProductGrowthRate(product);
    var textGrowth = extractGrowthText(text);
    if (directGrowth) return directGrowth;
    if (textGrowth) return textGrowth;

    if (heightTrait && typeof heightTrait.normalizedAverage === 'number') {
      return {
        value: classifyGrowthByHeight(heightTrait.normalizedAverage),
        evidence: heightTrait.evidence || [],
      };
    }

    return inferGrowthFromHabit(product, text, habitTrait);
  }

  function extractProductGrowthRate(product) {
    var value = product && product.growthRate;
    var normalized = normalizeGrowth(value);
    if (!normalized) return null;
    return {
      value: normalized,
      evidence: [{ text: value, key: 'growth', priority: 4 }],
    };
  }

  function extractGrowthText(text) {
    var sentences = splitSentences(text);
    var priority = sentences.filter(function (sentence) {
      return /\b(growth|growing|grower|grows|develops)\b/i.test(sentence);
    }).concat(sentences);
    var pattern = /\b(slow\s*(?:-|to|\/)\s*moderate|moderate\s*(?:-|to|\/)\s*fast|(?:extremely|really|very)\s+(?:slow|fast)|moderately\s+(?:slow|fast)|(?:slow|fast|faster|rapid|quick|medium|moderate)\s*(?:-| )?(?:growing|growth|grower|rate)|vigorous)\b/i;
    var adverbPattern = /\b(?:grows|develops)\s+(very\s+slowly|slowly|moderately|quickly|rapidly|fast)\b/i;

    for (var i = 0; i < priority.length; i += 1) {
      var sentence = priority[i];
      var match = sentence.match(pattern) || sentence.match(adverbPattern);
      if (match) {
        return {
          value: normalizeGrowth(match[1]),
          evidence: [{ text: match[0], key: 'growth', priority: 3 }],
        };
      }
    }
    return null;
  }

  function inferGrowthFromHabit(product, text, habitTrait) {
    var habitValue = normalizeSpaces(habitTrait && habitTrait.value || '');
    if (isSlowGrowthHabitValue(habitValue)) {
      return {
        value: 'Slow',
        evidence: getSlowGrowthHabitEvidence(habitTrait),
      };
    }

    var source = normalizeSpaces([
      product && product.title,
      product && product.habit,
      text,
      product && Array.isArray(product.tags) ? product.tags.join(' ') : '',
    ].join(' '));
    var matches = findHabitMatches(source).filter(function (match) {
      return isSlowGrowthHabitValue(match.value);
    });
    if (!matches.length) return null;

    return {
      value: 'Slow',
      evidence: matches.map(function (match) {
        return { text: match.text, key: 'growth', priority: 2 };
      }),
    };
  }

  function isSlowGrowthHabitValue(value) {
    return /\b(?:Dwarf|Compact)\b/i.test(value || '');
  }

  function getSlowGrowthHabitEvidence(habitTrait) {
    var evidence = habitTrait && Array.isArray(habitTrait.evidence) ? habitTrait.evidence : [];
    return evidence.filter(function (item) {
      return item && item.text && isSlowGrowthHabitText(item.text);
    }).map(function (item) {
      return { text: item.text, key: 'growth', priority: 2 };
    });
  }

  function isSlowGrowthHabitText(value) {
    return findHabitMatches(value).some(function (match) {
      return isSlowGrowthHabitValue(match.value);
    });
  }

  function parseFeetRange(value) {
    var normalized = normalizeRange(value);
    var parts = normalized.split('-').map(function (part) {
      return parseFloat(part);
    }).filter(function (part) {
      return isFinite(part);
    });
    if (!parts.length) return null;
    if (parts.length === 1) parts.push(parts[0]);
    return {
      min: Math.min(parts[0], parts[1]),
      max: Math.max(parts[0], parts[1]),
    };
  }

  function extractYearBasis(sentence) {
    var match = String(sentence || '').match(/\b(?:after|in|at|over|within|around|about)?\s*(\d+(?:\.\d+)?)\s*(?:-| )?\s*years?\b/i);
    if (!match) return 10;
    var years = parseFloat(match[1]);
    return isFinite(years) && years > 0 ? years : 10;
  }

  function normalizeHeightRangeToTenYears(range, sourceYears) {
    var multiplier = sourceYears && sourceYears > 0 ? 10 / sourceYears : 1;
    return {
      min: roundToHalfFoot(range.min * multiplier),
      max: roundToHalfFoot(range.max * multiplier),
    };
  }

  function buildHeightEvidence(sentence, match) {
    var heightText = match && match[0] ? match[0] : '';
    var heightIndex = typeof match.index === 'number' ? match.index : String(sentence).indexOf(heightText);
    var yearMatch = String(sentence || '').match(/\b(?:after|in|at|over|within|around|about)?\s*\d+(?:\.\d+)?\s*(?:-| )?\s*years?\b/i);
    if (!yearMatch || typeof yearMatch.index !== 'number' || heightIndex < 0) return heightText;

    var start = Math.min(heightIndex, yearMatch.index);
    var end = Math.max(heightIndex + heightText.length, yearMatch.index + yearMatch[0].length);
    return normalizeSpaces(String(sentence).slice(start, end));
  }

  function classifyGrowthByHeight(feetInTenYears) {
    var feetPerYear = Number(feetInTenYears || 0) / 10;
    if (!isFinite(feetPerYear) || feetPerYear <= 0) return 'Moderate';
    if (feetPerYear < GROWTH_RATE_THRESHOLDS.slowFeetPerYear) return 'Slow';
    if (feetPerYear > GROWTH_RATE_THRESHOLDS.fastFeetPerYear) return 'Fast';
    return 'Moderate';
  }

  function extractColors(product, source, descriptionText) {
    var sentences = splitSentences(descriptionText);
    var categories = [
      { label: 'Spring', pattern: /\b(spring|new growth|emerges?|flush)\b/i },
      { label: 'Fall', pattern: /\b(fall|autumn)\b/i },
      { label: 'Bloom', pattern: /\b(bloom|blooms|flower|flowers|flowering)\b/i },
      { label: 'Foliage', pattern: /\b(foliage|leaf|leaves|needles|color)\b/i },
    ];
    var parts = [];
    var evidence = [];
    var colorsByCategory = {
      Spring: findColors(product && product.springColor),
      Fall: findColors(product && product.fallColor),
      Bloom: findColors(product && product.bloomColor),
      Foliage: findColors(product && product.foliageColor),
    };

    categories.forEach(function (category) {
      sentences.forEach(function (sentence) {
        if (!category.pattern.test(sentence)) return;
        colorsByCategory[category.label] = colorsByCategory[category.label].concat(findColors(sentence));
      });
      var colors = unique(colorsByCategory[category.label]).slice(0, 5);
      if (colors.length) {
        parts.push(category.label + ': ' + colors.join(', '));
        colors.forEach(function (color) {
          evidence.push({ text: color, key: 'colors', priority: 1 });
        });
      }
    });

    if (!parts.length) {
      var fallbackColors = unique(findColors(source)).slice(0, 6);
      if (fallbackColors.length) {
        parts.push(fallbackColors.join(', '));
        fallbackColors.forEach(function (color) {
          evidence.push({ text: color, key: 'colors', priority: 1 });
        });
      }
    }

    if (!parts.length) return null;
    return {
      value: parts.slice(0, 4).join('; '),
      evidence: evidence,
    };
  }

  function findColors(text) {
    var found = [];
    COLOR_WORDS.forEach(function (word) {
      var re = new RegExp('\\b' + escapeRegExp(word) + '(?:s|ish)?\\b', 'ig');
      var match;
      while ((match = re.exec(text || ''))) {
        found.push({
          value: formatColor(match[0]),
          index: match.index,
        });
      }
    });
    return found.sort(function (a, b) {
      return a.index - b.index;
    }).map(function (item) {
      return item.value;
    });
  }

  function highlightText(text, traits) {
    var evidence = [];
    traits.forEach(function (trait) {
      (trait.evidence || []).forEach(function (item) {
        if (!item || !item.text) return;
        evidence.push({
          text: String(item.text),
          key: item.key || trait.key,
          priority: item.priority || 0,
        });
      });
    });

    evidence = uniqueEvidence(evidence)
      .filter(function (item) {
        return item.text.length > 1;
      })
      .sort(function (a, b) {
        return (b.priority - a.priority) || (b.text.length - a.text.length);
      });

    var ranges = [];
    var lower = text.toLowerCase();
    evidence.forEach(function (item) {
      var needle = item.text.toLowerCase();
      addEvidenceRanges(ranges, lower, needle, item.key);
    });

    if (!ranges.length) return escapeHtml(text);
    ranges.sort(function (a, b) {
      return a.start - b.start;
    });

    var html = '';
    var cursor = 0;
    ranges.forEach(function (range) {
      if (range.start < cursor) return;
      html += escapeHtml(text.slice(cursor, range.start));
      html += '<mark class="mm-product-compare__highlight mm-product-compare__highlight--' + escapeAttribute(range.key) + '">' + escapeHtml(text.slice(range.start, range.end)) + '</mark>';
      cursor = range.end;
    });
    html += escapeHtml(text.slice(cursor));
    return html;
  }

  function addEvidenceRanges(ranges, lowerText, needle, key) {
    if (!needle) return;
    if (shouldMatchWholeWord(needle)) {
      var pattern = new RegExp('(^|[^a-z0-9])(' + escapeRegExp(needle) + ')(?=$|[^a-z0-9])', 'g');
      var match;
      var count = 0;
      while ((match = pattern.exec(lowerText)) && count < 20) {
        var start = match.index + match[1].length;
        addRange(ranges, start, start + match[2].length, key);
        count += 1;
      }
      return;
    }

    var index = lowerText.indexOf(needle);
    var substringCount = 0;
    while (index !== -1 && substringCount < 20) {
      addRange(ranges, index, index + needle.length, key);
      index = lowerText.indexOf(needle, index + needle.length);
      substringCount += 1;
    }
  }

  function shouldMatchWholeWord(value) {
    return /^[a-z0-9]+$/.test(value);
  }

  function addRange(ranges, start, end, key) {
    if (start < 0 || end <= start) return;
    var overlaps = ranges.some(function (range) {
      return start < range.end && end > range.start;
    });
    if (!overlaps) ranges.push({ start: start, end: end, key: key });
  }

  function uniqueEvidence(items) {
    var seen = {};
    return items.filter(function (item) {
      var key = item.key + ':' + item.text.toLowerCase();
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function splitSentences(text) {
    var source = normalizeSpaces(text || '');
    if (!source) return [];

    var sentences = [];
    var start = 0;
    for (var i = 0; i < source.length; i += 1) {
      var character = source.charAt(i);
      if (character !== '.' && character !== '!' && character !== '?') continue;
      if (isProtectedSentencePunctuation(source, i)) continue;

      var next = source.charAt(i + 1);
      if (i < source.length - 1 && next && !/\s/.test(next)) continue;

      var sentence = source.slice(start, i + 1).trim();
      if (sentence) sentences.push(sentence);
      start = i + 1;
    }

    var remainder = source.slice(start).trim();
    if (remainder) sentences.push(remainder);
    return sentences;
  }

  function isProtectedSentencePunctuation(source, index) {
    var character = source.charAt(index);
    if (character !== '.') return false;

    var previous = source.charAt(index - 1);
    var next = source.charAt(index + 1);
    var nextAfterSpace = source.charAt(index + 2);
    if (/\d/.test(previous) && (/\d/.test(next) || /\s/.test(next) && /\d/.test(nextAfterSpace))) {
      return true;
    }

    var before = source.slice(Math.max(0, index - 4), index).toLowerCase();
    return /\b(?:ft|gal|qt|pt|in|yr)$/.test(before);
  }

  function htmlToText(html) {
    if (!html) return '';
    var source = String(html)
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/(p|h1|h2|h3|h4|h5|h6|div|li)>/gi, '\n');
    var element = document.createElement('div');
    element.innerHTML = source;
    element.querySelectorAll('script, style, iframe, noscript').forEach(function (node) {
      node.remove();
    });
    return normalizeDisplayText(element.textContent || '');
  }

  function cleanDescriptionText(value) {
    var output = normalizeDisplayText(value || '');
    DESCRIPTION_CLEANUP_PATTERNS.forEach(function (pattern) {
      output = output.replace(pattern, ' ');
    });
    return normalizeDisplayText(output);
  }

  function stripTags(value) {
    return String(value || '').replace(/<[^>]*>/g, '');
  }

  function decodeHtml(value) {
    var element = document.createElement('textarea');
    element.innerHTML = String(value || '');
    return normalizeSpaces(element.value);
  }

  function normalizeDisplayText(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[ \t\r\f\v]+/g, ' ')
      .replace(/\n[ \t]+/g, '\n')
      .replace(/[ \t]+\n/g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  function normalizeSpaces(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function normalizeHandle(value) {
    return String(value || '').trim().replace(/^\/+|\/+$/g, '').split('/').pop().toLowerCase();
  }

  function handleFromUrl(url) {
    var match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function titleizeHandle(handle) {
    return String(handle || '').split('-').map(function (part) {
      return part ? part.charAt(0).toUpperCase() + part.slice(1) : '';
    }).join(' ');
  }

  function normalizeRange(value) {
    return String(value || '')
      .replace(/(\d)\s*\.\s*(\d)/g, '$1.$2')
      .replace(/\s*(?:\u2013|\u2014|to)\s*/g, '-')
      .replace(/\s*-\s*/g, '-')
      .trim();
  }

  function roundToHalfFoot(value) {
    return Math.round(Number(value || 0) * 2) / 2;
  }

  function formatFeetRange(range) {
    if (!range) return '';
    var min = formatFeetValue(range.min);
    var max = formatFeetValue(range.max);
    return min === max ? min : min + '-' + max;
  }

  function formatFeetValue(value) {
    var rounded = roundToHalfFoot(value);
    return Math.abs(rounded - Math.round(rounded)) < 0.001
      ? String(Math.round(rounded))
      : rounded.toFixed(1).replace(/\.0$/, '');
  }

  function cleanNumber(value) {
    return String(value || '').replace(/\.0$/, '');
  }

  function formatZoneNumber(value) {
    return normalizeSpaces(value || '')
      .replace(/\s+/g, '')
      .replace(/\.0$/, '')
      .replace(/^(\d+)([ab])$/i, function (_, number, suffix) {
        return number + suffix.toLowerCase();
      });
  }

  function normalizeVariantId(value) {
    if (typeof value === 'number' && isFinite(value)) return String(Math.round(value));
    var normalized = String(value || '').trim();
    var gidMatch = normalized.match(/\/Variant\/(\d+)$/);
    if (gidMatch) return gidMatch[1];
    return normalized.replace(/[^0-9]/g, '');
  }

  function parseBoolean(value) {
    if (value === true || value === 'true') return true;
    if (value === false || value === 'false') return false;
    if (value === 1 || value === '1') return true;
    if (value === 0 || value === '0') return false;
    return null;
  }

  function routePath(path) {
    var routes = window.Theme && window.Theme.routes ? window.Theme.routes : {};
    var named = {
      'cart/add.js': routes.cart_add_url ? routes.cart_add_url.replace(/\/?$/, '') + '.js' : '',
      'cart.js': routes.cart_url ? routes.cart_url.replace(/\/?$/, '') + '.js' : '',
      checkout: '/checkout',
    };
    if (named[path]) return named[path];
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function normalizeGrowth(value) {
    var lower = normalizeSpaces(value || '').toLowerCase();
    if (!lower) return '';
    if (/\b(?:slow\s*(?:-|to|\/)\s*moderate|moderate\s*(?:-|to|\/)\s*fast)\b/.test(lower)) return 'Moderate';
    if (/\b(?:moderately\s+slow|slow|slowly)\b/.test(lower)) return 'Slow';
    if (/\b(?:medium|moderate|moderately\s+fast|moderately)\b/.test(lower)) return 'Moderate';
    if (/\b(?:fast|faster|vigorous|quick|quickly|rapid|rapidly)\b/.test(lower)) return 'Fast';
    return '';
  }

  function normalizeHabit(value) {
    var source = normalizeSpaces(value || '');
    if (!source) return '';
    var matches = [];
    addHabitMatches(matches, source);
    if (matches.length) {
      return matches.map(function (match) {
        return match.value;
      }).join(', ');
    }
    return source.charAt(0).toUpperCase() + source.slice(1);
  }

  function formatColor(value) {
    var raw = String(value || '').toLowerCase();
    var normalized = COLOR_LABELS[raw] ? raw : raw.replace(/ish$/, '').replace(/s$/, '');
    var label = COLOR_LABELS[normalized] || normalized.charAt(0).toUpperCase() + normalized.slice(1);
    return label;
  }

  function unique(values) {
    var seen = {};
    return values.filter(function (value) {
      var key = String(value).toLowerCase();
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }

  function escapeRegExp(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
